import { render, staticRenderFns } from "./LogDetailsList.vue?vue&type=template&id=61201e0c&scoped=true&"
import script from "./LogDetailsList.vue?vue&type=script&lang=js&"
export * from "./LogDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./LogDetailsList.vue?vue&type=style&index=0&id=61201e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61201e0c",
  null
  
)

export default component.exports